import { Avatar, Text, Group, Container, Anchor, Badge, Card, ActionIcon, Title } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import TripProfileTable from '@components/trip-profiles-table';
import { gql } from '@src/__generated__';
import LoadingData from '@components/graphql-loading-data';
import GraphqlError from '@components/graphql-error';
import { IconMailFilled, IconPhoneFilled, IconChevronsLeft } from '@tabler/icons-react';
import { Link } from 'react-router-dom';
import classes from './client-details.module.css';

const GET_CLIENT = gql(`
  query GetClient($id: ID!) {
    singleClient(id: $id) {
      id
      firstName
      lastName
      status
      email
      phone
      avatar
    }
  }
`);

function ClientDetails() {
  const { clientId } = useParams();
  const { loading, error, data } = useQuery(GET_CLIENT, {
    variables: {
      id: clientId || '',
    },
  });
  if (loading) return <LoadingData />;
  if (error) return <GraphqlError error={error} />;
  if (!data) return <div />;
  const client = data.singleClient;

  return (
    <Container fluid mt={20}>
      <Group justify="flex-start" mb="xs">
        <ActionIcon variant="default" color="voyPurple" component={Link} to="/clients" aria-label="Back to clients">
          <IconChevronsLeft />
        </ActionIcon>
        <Title order={3}>CLIENT DETAILS</Title>
      </Group>
      <Card shadow="xs" radius="xl" p="md" bg="voyCream.6" className={classes.box}>
        <Group justify="space-between">
          <Group align="center" gap="md">
            <Avatar src={client.avatar} size={50} radius={100} />
            <Group align="center" gap="xs">
              <Text className={classes.textAvatar}>
                {client.firstName} {client.lastName}
              </Text>
              {client.status && (
                <Badge variant="light" color="voyMutedPurple">
                  {client.status}
                </Badge>
              )}
            </Group>
            {/* Left cluster: avatar + name + status only */}
          </Group>

          {/* Right cluster: contact info (email + phone), right-aligned */}
          <Group align="center" gap="lg" justify="flex-end" wrap="wrap">
            {client.email && (
              <Text className={`${classes.text} ${classes.inline}`}>
                <IconMailFilled className={classes.icon} />
                <Anchor href={`mailto:${client.email}`}>{client.email}</Anchor>
              </Text>
            )}
            {client.phone && (
              <Text className={`${classes.text} ${classes.inline}`}>
                <IconPhoneFilled className={classes.icon} />
                <Anchor href={`tel:${client.phone}`}>{client.phone}</Anchor>
              </Text>
            )}
          </Group>
        </Group>
      </Card>
      <TripProfileTable clientId={client.id} />
    </Container>
  );
}

export default ClientDetails;
